import * as React from 'react';
import * as PropTypes from 'prop-types';

import { GDPR_PREFERENCES_COOKIE } from '@wkda/gdprlib';

import { GDPRBanner } from './GDPRBanner';
import { PTAPIService, PTContent, PTCookieSerice } from './pTypes';
import { GDPRBannerStateProvider } from './useGDPRBannerContext';

/**
 * @param {Object} props
 * @param {import('./GDPRBanner').GDPRBannerContent} props.content
 * @param {import('./useGDPRBannerContext').CookieService} props.cookieService
 * @param {boolean} props.isProd
 * @param {import('./useGDPRBannerContext').APIService} props.APIService
 * @param {() => void} props.closeHandler
 * @param {() => void} [props.onSubmit]
 * @param {string} [props.className]
 * @param {boolean} [props.ignorePreferencesCookie]
 */

function GDPRContainer({
  cookieService,
  isProd,
  APIService,
  content,
  closeHandler,
  onSubmit,
  className,
  ignorePreferencesCookie = false,
}) {
  const [canRender, setCanRender] = React.useState(false);
  React.useEffect(() => {
    if (
      content &&
      (ignorePreferencesCookie || !cookieService.get(GDPR_PREFERENCES_COOKIE))
    ) {
      setCanRender(true);
    } else if (typeof closeHandler === 'function') {
      closeHandler();
    }
  }, []);

  return canRender ? (
    <GDPRBannerStateProvider
      cookieService={cookieService}
      isProd={isProd}
      APIService={APIService}
      onSubmit={onSubmit}
    >
      <GDPRBanner
        content={content}
        onClose={closeHandler}
        className={className}
      />
    </GDPRBannerStateProvider>
  ) : null;
}

GDPRContainer.propTypes = {
  content: PTContent,
  cookieService: PTCookieSerice.isRequired,
  isProd: PropTypes.bool.isRequired,
  APIService: PTAPIService.isRequired,
  closeHandler: PropTypes.func,
  onSubmit: PropTypes.func,
  className: PropTypes.string,
  ignorePreferencesCookie: PropTypes.bool,
};

export { GDPRContainer as GDPRBanner };
